import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M.75 5.708a4.9 4.9 0 0 0 .525 2.217 4.96 4.96 0 0 0 4.433 2.742 4.9 4.9 0 0 0 2.217-.525l3.325 1.108-1.108-3.325a4.9 4.9 0 0 0 .525-2.217 4.96 4.96 0 0 0-2.742-4.433A4.9 4.9 0 0 0 5.708.75h-.291A4.947 4.947 0 0 0 .75 5.417z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "dialog"}) } }